// extracted by mini-css-extract-plugin
module.exports = {"h1":"heading_h1__KZ8SV","h2":"heading_h2__2cO0G","h3":"heading_h3__yJ0ks","h4":"heading_h4__5Kb_J","count":"heading_count__3yqK2"};